import { sceconfig } from 'sce-core';

export const environment = {
  production: false,
  logger: 'console',
  baseUrlUI: sceconfig.wms.baseUrlUI,
  // wmsApiBaseUrl: 'https://ofsce-dev.lflogistics.net/scecommon/',  // localhost envrionment
  //  wmsApiBaseUrl: 'https://ofsce-sit.lflogistics.net/scecommon/', // sit envrionment
  // wmsApiBaseUrl: 'https://ofsce-uat.lflogistics.net/scecommon/', // uat envrionment

  //  notificationApiBaseUrl : 'https://ofscetms-uat.lflogistics.net/api' // uat envrionment
  // notificationApiBaseUrl : 'https://ofscetms-sit.lflogistics.net/api' // sit envrionment
  // notificationApiBaseUrl: 'https://ofscetms-dev.lflogistics.net/api' // localhost envrionment

  wmsApiBaseUrl: 'https://sit-wms.ocf.fulfillment.maersk.com/scecommon/', // wrb sit envrionment
  notificationApiBaseUrl: 'https://sit-tms.ocf.fulfillment.maersk.com/api', // wrb sit envrionment

  RUM_APP_ID: 'TMSWeb-SIT',
  RUM_API_KEY:
    'QtjiBXrUPLjJc89LMdBHzhd7UJJoP9NvN46q7gN1/q7Hn2eUR3QOvlmVYK1WFg==',
};
